/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from "react";
import "./LoginPage.css";
import { Navigate, useNavigate } from "react-router-dom";
import Notification from "../../components/Common/Notification";
import ajaxAuth from "../../util/remote/ajaxAuth";

const ForgotPasswordPage = () => {
  const [step, setStep] = useState(1); // 1: email, 2: code, 3: new password
  const [username, setUsername] = useState("");
  const [code, setCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [notify, setNotify] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const isLoggedIn = localStorage.getItem("eschool@user");
  if (isLoggedIn) return <Navigate to="/dashboard" />;

  useEffect(() => {
    if (!loading && notify) {
      const timer = setTimeout(() => setNotify(null), 5000);
      return () => clearTimeout(timer);
    }
  }, [notify, loading]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (step === 1) {
      if (!username) return setNotify(<Notification message="Enter your username" type="danger" />);
      setLoading(true);
      const res = await ajaxAuth.sendPasswordResetCode(username);
      setLoading(false);
      if (res.status === "OK") {
        setNotify(<Notification message={res.message} type="success" />);
        setStep(2);
      } else {
        setNotify(<Notification message={res.message} type="danger" />);
      }
    }

    else if (step === 2) {
      if (!code) return setNotify(<Notification message="Enter the code sent to your email" type="danger" />);
      setLoading(true);
      const res = await ajaxAuth.verifyPasswordResetCode(username, code);
      setLoading(false);
      if (res.status === "OK") {
        setNotify(<Notification message={res.message} type="success" />);
         localStorage.setItem('eschool@user', res.details.token);
          navigate('/dashboard')
          window.location.reload();
        setStep(3);
      } else {
        setNotify(<Notification message={res.message} type="danger" />);
      }
    }

    else if (step === 3) {
      if (!newPassword) return setNotify(<Notification message="Enter a new password" type="danger" />);
      setLoading(true);
      const res = await ajaxAuth.resetPassword(username, code, newPassword);
      setLoading(false);
      if (res.status === "OK") {
        setNotify(<Notification message="Password changed successfully" type="success" />);
        navigate("/login");
      } else {
        setNotify(<Notification message={res.message} type="danger" />);
      }
    }
  };

  const handleBackToEmail = () => {
    setStep(1);
    setCode("");
    setNotify(null);
  };

  return (
    <div className="content">
      <div className="container">
        <div className="row">
          {/* Left Image */}
          <div className="col-md-6">
            <div className="text-left mb-4">
              <img src="assets/images/logo.svg" alt="logo" className="logo" style={{ maxWidth: "60px", position: "absolute" }} />
            </div>
            <img src="assets/images/undraw_remotely_2j6y.svg" alt="Illustration" className="img-fluid" />
          </div>

          {/* Right Section */}
          <div className="col-md-6 contents">
            <div className="row justify-content-center">
              <div className="col-md-8">
                <div className="mb-4">
                  <h3>Reset Password</h3>
                  <p className="mb-4">Follow the steps below to reset your password.</p>
                </div>

                <form onSubmit={handleSubmit}>
                  {notify}

                  {step === 1 && (
                    <div className={`form-group first ${username ? "field--not-empty" : ""}`}>
                      <label htmlFor="username">Enter your username or email address</label>
                      <input type="text" className="form-control" id="username" value={username} onChange={(e) => setUsername(e.target.value)} required />
                    </div>
                  )}

                  {step === 2 && (
                    <>
                      <div className={`form-group first ${code ? "field--not-empty" : ""}`}>
                        <label htmlFor="code">Enter Code</label>
                        <input type="text" className="form-control" id="code" value={code} onChange={(e) => setCode(e.target.value)} required />
                      </div>
                      <button type="button" onClick={handleBackToEmail} className="btn btn-link p-0 mt-2">← Change email address</button>
                    </>
                  )}

                  {step === 3 && (
                    <div className={`form-group first ${newPassword ? "field--not-empty" : ""}`}>
                      <label htmlFor="newPassword">New Password</label>
                      <input type="password" className="form-control" id="newPassword" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required />
                    </div>
                  )}

                  <input type="submit" value={loading ? "Processing..." : "Continue"} className="btn btn-block btn-primary mt-4" disabled={loading} />
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
